import React from "react";
import "../styles/CollectivePreviewPage.css";

export default function CollectivePreviewPage() {
  return (
    <div className="ttysix-preview-page">

      <div className="ttysix-preview-header">
        <span className="ttysix-preview-header__dots">•••</span>
        <span className="ttysix-preview-header__label">Design Preview</span>
      </div>

      <div className="ttysix-preview-canvas">
        <img
          src="/static/img/mamahood_homepage2.png"
          alt="Mamahood homepage design preview"
          className="ttysix-preview-image"
        />
      </div>

    </div>
  );
}
